import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge, RiskBadge, Spinner, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Customers() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/customers").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Spinner />;

  const filtered = rows.filter((c) => (c.name + c.code + c.division).toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader overline="Clients" title="Customers" subtitle="Click a customer to open the consolidated Customer 360 view." testid="customers-header" />
      <Card className="p-4 sm:p-5">
        <Input placeholder="Search by name, code or division…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm mb-4" data-testid="customer-search" />
        {filtered.length === 0 ? <EmptyState title="No customers found" /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Code</TableHead><TableHead>Name</TableHead><TableHead>Type</TableHead>
                  <TableHead>Division</TableHead><TableHead>Residence</TableHead>
                  <TableHead>Onboarding</TableHead><TableHead>Compliance</TableHead><TableHead>Risk</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filtered.map((c) => (
                  <TableRow key={c.id} className="cursor-pointer" onClick={() => navigate(`/customers/${c.id}`)} data-testid={`customer-row-${c.code}`}>
                    <TableCell className="font-num text-xs">{c.code}</TableCell>
                    <TableCell className="font-medium">{c.name}</TableCell>
                    <TableCell className="capitalize">{c.type}</TableCell>
                    <TableCell>{c.division}</TableCell>
                    <TableCell>{c.residence}</TableCell>
                    <TableCell><StatusBadge status={c.onboarding_status} /></TableCell>
                    <TableCell><StatusBadge status={c.compliance_status} /></TableCell>
                    <TableCell><RiskBadge rating={c.risk_rating} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
